import { __module as e } from "./index836.mjs";
import { _ as v } from "./index837.mjs";
import { s as x } from "./index838.mjs";
e.exports;
(function(r, f) {
  var a = v, i = x, o = f && !f.nodeType && f, s = o && !0 && r && !r.nodeType && r, p = s && s.exports === o, t = p ? a.Buffer : void 0, u = t ? t.isBuffer : void 0, n = u || i;
  r.exports = n;
})(e, e.exports);
var _ = e.exports;
export {
  _ as i
};
